const safePostMessage = (iframe, message, targetOrigin, logger) => {
  if (!iframe || !iframe.contentWindow) {
    logger.error('{chargifyjs} Cannot send message - iframe unavailable', message);
    return;
  }

  iframe.contentWindow.postMessage(message, targetOrigin);
};

export default {
  safePostMessage: safePostMessage,
};
